import ProductsGrid from './ProductsGrid/index';
export default ProductsGrid;
